import { useEffect, useState } from 'react';
import { useMediaQuery } from '@react-hook/media-query';
import { MOBILE_MEDIA_QUERY } from './constants';

export const useScreenSize = () => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    setIsMobileView(isMobile);
  }, [isMobile]);

  return { isMobileView };
};
